import Immutable from 'immutable';
import moment from 'moment';

import { itemToMoment } from 'sharedreact/utils/MomentSupport';

const Content: {
  id: string,
  name: string,
  modificationDate: moment.Moment | null,
  fileSize: number
} = {
  id: '',
  name: '',
  modificationDate: null,
  fileSize: 0
};

class FontFile extends Immutable.Record(Content) {
  static fromJS (json: object): FontFile {
    return new FontFile(Immutable.Map<string, unknown>(json).map(itemToMoment));
  }
}

export default FontFile;
